import moment from 'moment';

class Vehicle {
    public brandId?: number;
    public brand?: string;
    public licensePlate: string;
    public colorId?: number;
    public color?: string;
    public model: string;
    public outfitting?: string;
    public registrationDate?: moment.Moment;
    public value: number;

    constructor(
        brandId?: number,
        brand?: string,
        licensePlate?: string,
        colorId?: number,
        color?: string,
        model?: string,
        outfitting?: string,
        registrationDate?: moment.Moment,
        value?: number
    ) {
        this.brandId = brandId || undefined;
        this.brand = brand || undefined;
        this.licensePlate = licensePlate || '';
        this.colorId = colorId || undefined;
        this.color = color || undefined;
        this.model = model || '';
        this.outfitting = outfitting || undefined;
        this.registrationDate = registrationDate || moment();
        this.value = value || 0;
    }
}

export default Vehicle;
